"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),i=require("react/jsx-runtime"),t=require("@vds/notifications"),a=require("styled-components"),s=require("@vds/typography"),d=require("@vds/buttons"),n=require("@plans/blocks"),o=require("@vds/lists"),l=require("@vds-tokens/core"),r=require("@vds/lines"),p=require("@vds/tabs"),c=require("@vds/radio-boxes"),u=require("@plans/utilities"),m=require("@vds/utilities"),h=require("@plans/type-lockups");function x(e){return e&&e.__esModule?e:{default:e}}var f=x(a);const g=f.default.div.withConfig({displayName:"Wrapper",componentId:"VDS__sc-ddfr9l-0"})`
  background-color: ${({surface:e})=>l.ColorTokens.background.secondary[`${e}`].value};
  border-radius: 8px;
  padding: ${l.LayoutTokens.space["6X"].value} ${l.LayoutTokens.space["4X"].value};
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    padding: ${l.LayoutTokens.space["6X"].value};
  }
`,b=f.default.div.withConfig({displayName:"HeaderTitleWrapper",componentId:"VDS__sc-ddfr9l-1"})``,j=f.default.div.withConfig({displayName:"HeaderTextLinkWrapper",componentId:"VDS__sc-ddfr9l-2"})``,v=f.default.div.withConfig({displayName:"HeaderWrapper",componentId:"VDS__sc-ddfr9l-3"})`
  align-items: top;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: ${l.LayoutTokens.space["6X"].value};
  padding-top: ${l.LayoutTokens.space["2X"].value};
  width: 100%;
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    padding-bottom: ${l.LayoutTokens.space["8X"].value};
    padding-top: 0px;
  }
`,y=f.default.div.withConfig({displayName:"DeviceWrapper",componentId:"VDS__sc-ddfr9l-4"})`
  width: 100%;
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    padding-bottom: ${l.LayoutTokens.space["6X"].value};
  }
`,w=f.default.div.withConfig({displayName:"DevicePlanWrapper",componentId:"VDS__sc-ddfr9l-5"})`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    flex-direction: row;
    gap: 40px;
    justify-content: space-between;
  }
`,k=f.default.div.withConfig({displayName:"PlanWrapper",componentId:"VDS__sc-ddfr9l-6"})`
  display: flex;
  flex-direction: column-reverse;
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    width: 100%;
    gap: 40px;
    flex-direction: row;
    > div {
      width: 50%;
    }
  }
`,_=f.default.div.withConfig({displayName:"HelperTextWrapper",componentId:"VDS__sc-ddfr9l-7"})``,T=f.default.div.withConfig({displayName:"HelperTextLineWrapper",componentId:"VDS__sc-ddfr9l-8"})`
  padding: ${l.LayoutTokens.space["6X"].value} 0px;
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    padding: ${l.LayoutTokens.space["8X"].value} 0px;
  }
`,S=f.default.div.withConfig({displayName:"StaticLineWrapper",componentId:"VDS__sc-ddfr9l-9"})`
  padding: ${l.LayoutTokens.space["6X"].value} 0px;
`,L=f.default.div.withConfig({displayName:"TextLinkWrapper",componentId:"VDS__sc-ddfr9l-10"})`
  display: flex;
  justify-content: ${({left:e})=>e?"start":"center"};
  > div > div > :last-child {
    padding: 0px;
  }
`,$=f.default.div.withConfig({displayName:"ButtonGroupWrapper",componentId:"VDS__sc-ddfr9l-11"})`
  > div > :last-child {
    padding-bottom: 0px;
  }
`,I=f.default.div.withConfig({displayName:"ProtectionBlockWrapper",componentId:"VDS__sc-ddfr9l-12"})``,O=f.default.div.withConfig({displayName:"ShippingWrapper",componentId:"VDS__sc-ddfr9l-13"})`
  width: 100%;
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    display: flex;
    height: 100%;
    padding-top: ${l.LayoutTokens.space["8X"].value};
  }
`,D=f.default.div.withConfig({displayName:"RadioGroupWrapper",componentId:"VDS__sc-ddfr9l-14"})`
  padding-bottom: ${l.LayoutTokens.space["3X"].value};
  padding-top: ${l.LayoutTokens.space["3X"].value};
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    width: 50%;
    padding-bottom: 0px;
    padding-right: 40px;
    > div > :last-child {
      margin-bottom: 0px;
    }
  }
`,C=f.default.div.withConfig({displayName:"ShippingListWrapper",componentId:"VDS__sc-ddfr9l-15"})`
  width: 100%;
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    width: 50%;
    padding-bottom: 0px;
  }
  > div > :first-child {
    padding-top: 0px;
  }
  > div > :last-child {
    padding-bottom: 0px;
  }
`,N=f.default.div.withConfig({displayName:"TabsWrapper",componentId:"VDS__sc-ddfr9l-16"})`
  width: 100%;
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    width: 100%;
    box-sizing: border-box;
  }
`,V=f.default.div.withConfig({displayName:"TabContainer",componentId:"VDS__sc-ddfr9l-17"})`
  width: 100%;
  @media (min-width: ${u.breakpoints.tabletSmall.min}) {
    width: 100%;
    display: flex;
    padding-top: ${l.LayoutTokens.space["6X"].value};
  }
`,W=f.default.div.withConfig({displayName:"NotificationWrapper",componentId:"VDS__sc-ddfr9l-18"})`
  padding-bottom: ${l.LayoutTokens.space["6X"].value};
  padding-top: ${l.LayoutTokens.space["2X"].value};
`;var X=m.withVDSManager((({showNotification:a=!0,notification:u,header:m,device:x,surface:f="light",plan:X,viewport:q,protection:B,helperText:G,shipping:z,buttonGroup:P})=>{var H;return i.jsxs(g,Object.assign({surface:f},{children:[a&&u&&i.jsx(W,{children:i.jsx(t.Notification,Object.assign({viewport:"mobile"},u))}),m&&i.jsxs(v,{children:[m.title&&i.jsx(b,{children:i.jsx(s.Body,Object.assign({size:"large",color:l.ColorTokens.elements.secondary[`on${f}`].value},m.title))}),m.textLink&&i.jsx(j,{children:i.jsx(d.TextLink,Object.assign({surface:f,type:"standAlone",size:"small"},m.textLink))})]}),!x&&!X&&P&&i.jsx($,{children:i.jsx(d.ButtonGroup,Object.assign({surface:f},P))}),x&&i.jsxs(w,{children:[i.jsxs("div",{children:[i.jsx(y,{children:i.jsx(n.Device,Object.assign({surface:f,variant:"mobile"===q?"default":"reverse"},x))}),"mobile"!==q&&P&&i.jsx(L,Object.assign({left:!0},{children:i.jsx("div",{children:i.jsx(d.ButtonGroup,Object.assign({surface:f},P))})}))]}),"mobile"===q&&i.jsx(S,{children:i.jsx(r.Line,{type:"secondary"})}),X&&i.jsxs("div",Object.assign({style:{display:"flex",flexDirection:"column",width:"100%"}},{children:[i.jsx(n.Plan,Object.assign({surface:f},X,{list:Object.assign({size:"medium"},X.list)})),B&&i.jsxs(i.Fragment,{children:[i.jsx(S,{children:i.jsx(r.Line,{type:"secondary"})}),i.jsxs(I,{children:[i.jsx(s.Body,Object.assign({size:"large",color:l.ColorTokens.elements.secondary[`on${f}`].value},B.lineAttribution)),i.jsx(s.Body,Object.assign({color:"dark"===f?"white":"",size:"large"},B.reviewItem)),i.jsx(h.Pricing,Object.assign({surface:f},B.price))]})]})]}))]}),X&&!x&&i.jsxs(k,{children:[P&&i.jsx($,{children:i.jsx(d.ButtonGroup,Object.assign({surface:f,childWidth:"100%",alignment:"center"},P))}),"mobile"===q&&i.jsx(S,{children:i.jsx(r.Line,{type:"secondary"})}),i.jsx(n.Plan,Object.assign({surface:f},X,{list:Object.assign({size:"medium"},X.list)}))]}),(null==z?void 0:z.tabs)&&i.jsxs(i.Fragment,{children:["mobile"===q&&i.jsx(S,{children:i.jsx(r.Line,{type:"secondary"})}),i.jsx(O,{children:i.jsx(N,{children:i.jsx(p.Tabs,Object.assign({surface:f},z.tabs.tab,{children:null===(H=z.tabs)||void 0===H?void 0:H.tabDetails.map(((t,a)=>{var d,n,r,u,m,h;return e.createElement(p.Tab,Object.assign({},t,{key:a}),i.jsx(V,{children:z&&i.jsxs(i.Fragment,{children:[i.jsx(D,{children:(null===(d=z.shippingTab[a])||void 0===d?void 0:d.radioBoxGroup)&&i.jsx(c.RadioBoxGroup,Object.assign({surface:f},null===(n=z.shippingTab[a])||void 0===n?void 0:n.radioBoxGroup))}),i.jsx(C,{children:(null===(r=z.shippingTab[a])||void 0===r?void 0:r.listItem)&&i.jsxs(o.ListGroupItem,Object.assign({surface:f},null===(u=z.shippingTab[a])||void 0===u?void 0:u.listItem,{children:[i.jsx(o.ListGroupItemTitle,{children:i.jsx(s.Body,Object.assign({size:"large",color:"dark"===f?"white":""},null===(m=z.shippingTab[a].listItem)||void 0===m?void 0:m.title))}),i.jsx(o.ListGroupItemSubtitle,{children:i.jsx(s.Body,Object.assign({color:l.ColorTokens.elements.secondary[`on${f}`].value,size:"small"},null===(h=z.shippingTab[a].listItem)||void 0===h?void 0:h.subtitle))})]}))})]})}))}))}))})})]}),G&&i.jsxs(i.Fragment,{children:[i.jsx(T,{children:i.jsx(r.Line,{type:"secondary"})}),i.jsx(_,{children:i.jsx(n.HelperText,Object.assign({surface:f},G))}),"mobile"===q&&i.jsx(S,{children:i.jsx(r.Line,{type:"secondary"})})]}),"mobile"===q&&x&&P&&i.jsx(L,{children:i.jsx("div",{children:i.jsx(d.ButtonGroup,Object.assign({surface:f},P))})})]}))}));exports.default=X;
